export enum ReportsOpportunityRoutes {
    closedwonopportunitysummary = "closed-summary",
    closedwonopportunitydetail = "closed-won",
    openopportunitybyowner= "open-opportunities-by-owner",
    opportunitybycloseddatestagesummary = "opportunity-stages-summary",
    opportunitybycloseddatestagedetail = "opportunity-stages-details",
    performancebysales = "performance-by-sales-person",
    opportunityqualitymetricssummary = "quality-metrics-summary",
    opportunityqualitymetricsdetail = "quality-metrics-details",
    opportunitypipelinesummary = "pipe-line-summary",
    opportunitypipelinedetail = "pipe-line-details"
}

export enum ReportsOpportunityTypes {
    closedwonopportunitysummary = "closedwonopportunitysummary",
    closedwonopportunitydetail = "closedwonopportunitydetail",
    openopportunitybyowner = "openopportunitybyowner",
    opportunitybycloseddatestagesummary = "opportunitybycloseddatestagesummary",
    opportunitybycloseddatestagedetail = "opportunitybycloseddatestagedetail",
    performancebysales = "winlosssalesanalysis",
    opportunityqualitymetricssummary = "opportunityqualitymetricssummary",
    opportunityqualitymetricsdetail = "opportunityqualitymetricsdetail",
    opportunitypipelinesummary = "opportunitypipelinesummary",
    opportunitypipelinedetail = "opportunitypipelinedetail"
}

export enum ReportsOpportunityPermissions {
    closedwonopportunitysummary = "Closed Won Opportunity (Summary)",
    closedwonopportunitydetail = "Closed Won Opportunity (Details)",
    openopportunitybyowner = "Closed Won Opportunity (Details)",
    opportunitybycloseddatestagesummary = "Opportunity by Close Date and Opportunity Stage (Summary)",
    opportunitybycloseddatestagedetail = "Opportunity by Close Date and Opportunity Stage (Details)",
    winlosssalesanalysis = "Closed Won Opportunity (Details)",
    opportunityqualitymetricssummary = "Opportunity Quality Metrics (Summary)",
    opportunityqualitymetricsdetail = "Opportunity Quality Metrics (Details)",
    opportunitypipelinesummary = "Opportunity Pipeline Summary",
    opportunitypipelinedetail = "Opportunity Pipeline Detail"
}
